import { render, staticRenderFns } from "./RoomScreenDetail.vue?vue&type=template&id=a4d59b48&scoped=true&"
import script from "./RoomScreenDetail.vue?vue&type=script&lang=js&"
export * from "./RoomScreenDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoomScreenDetail.vue?vue&type=style&index=0&id=a4d59b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d59b48",
  null
  
)

component.options.__file = "RoomScreenDetail.vue"
export default component.exports